import url from './url';
const AppConsts = {
  userManagement: {
    defaultAdminUserName: 'admin',
  },
  localization: {
    defaultLocalizationSourceName: 'CharterScanners',
  },
  authorization: {
    encrptedAuthTokenName: 'enc_auth_token',
  },
  appBaseUrl: 'http://localhost:8081',
  remoteServiceBaseUrl: url.endsWith('/') ? url.slice(0, -1) : url,
};
export default AppConsts;
